<!-- src/views/property/index.vue -->
<template>
	<div class="app-body">
		<div class="a-flex-rsbc a-ptb-6">
			<span class="a-fs-16">资产评估列表</span>
			<!-- <el-button icon="el-icon-upload2" class="s-btn-exp">导出</el-button> -->
		</div>

		<el-card class="el-main">
			<!-- 搜索表单 -->
			<le-search-form id="leSearch" @reset="handlerRest" @search="handlerSearch">
                <le-input-district-choose  label="省市区" :province.sync="pageParam.params.provinceCode" :city.sync="pageParam.params.cityCode" :area.sync="pageParam.params.districtCode"></le-input-district-choose>
				<le-input label="用户手机号" v-model="pageParam.params.userPhone" placeholder="请输入手机号" />
				<le-date-range 
					label="评估时间" 
					:minDate.sync="pageParam.params.startTime" 
					:maxDate.sync="pageParam.params.endTime" 
					:defaultTime="['00:00:00','23:59:59']"
					valueFormat="yyyy-MM-dd HH:mm:ss" />
			</le-search-form>
			<!-- 分页表格 -->
			<le-pagview @setData="setTableData" :pageParam="pageParam" :total.sync="total" ref="propertyPage" :isFixed="true" :tableRef="$refs.propertyList">
				<el-table :data="tableData" :highlight-current-row="true" ref="propertyList" v-sticky="{ top: 0, parent:'.el-card__body' }">
					<!-- 评估用户 -->
					<el-table-column prop="userPhone" label="评估用户" >
						<template slot-scope="{ row }">
							<span>{{ row.userPhone }}</span>
						</template>
					</el-table-column>

					<!-- 评估时间 -->
					<el-table-column prop="assessmentTime" label="评估时间" >
						<template slot-scope="{ row }">
							<span>{{ row.evalTime }}</span>
						</template>
					</el-table-column>
                    <!-- 所在城市 -->
					<el-table-column prop="city" label="所在城市" >
						<template slot-scope="{ row }">
							<span>{{ row.provinceName }}{{ row.cityName }}{{ row.districtName }}</span>
						</template>
					</el-table-column>

					<!-- 资产估值 -->
					<el-table-column prop="assetValue" label="资产估值(w)"  >
						<template slot-scope="{ row }">
							<span>{{ row.evalValue }}</span>
						</template>
					</el-table-column>

					<!-- 操作 -->
					<el-table-column label="操作" width="100" fixed="right">
						<template slot-scope="{ row }">
							<el-button type="text" @click="handleViewDetail(row)">查询详情</el-button>
						</template>
					</el-table-column>
				</el-table>
                <template slot="footerContent" slot-scope="scope" >
                    <div class="a-flex-rfsc">
                        <div class="a-flex-rfsc">
                            <span class="a-fs-12 a-c-normal">资产评估数量：</span>
                            <span class="a-fs-16 a-c-master a-fw-b">{{ total }}</span>
                        </div>
                    </div>
                </template>
			</le-pagview>
		</el-card>

		<!-- 详情弹窗 -->
		<el-dialog title="资产评估详情" :visible.sync="detailDialogVisible" width="750px" :close-on-click-modal="false">
			<div class="detail-content">
				<!-- 资产估值单独模块 -->
				<div class="detail-asset-value">
					<div class="asset-label">资产估值</div>
					<div class="asset-value">{{ currentRow.evalValue || '-' }}<span class="asset-unit">w</span></div>
				</div>
				
				<!-- 基础信息 -->
				<div class="detail-grid">
					<div class="detail-item">
						<span class="detail-label">评估用户</span>
						<span class="detail-value">{{ currentRow.userPhone || '-' }}</span>
					</div>
					<div class="detail-item">
						<span class="detail-label">评估时间</span>
						<span class="detail-value">{{ currentRow.evalTime || '-' }}</span>
					</div>
					<div class="detail-item">
						<span class="detail-label">所在城市</span>
						<span class="detail-value">{{ (currentRow.provinceName || '') + (currentRow.cityName || '') + (currentRow.districtName || '') || '-' }}</span>
					</div>
					<div v-for="item in currentRow.detailParams" :key="item.paramKey" class="detail-item">
                        <!-- <img v-if="item.icon" :src="item.icon" class="detail-icon" /> -->
                        <span class="detail-label">{{ item.paramName }}</span>
                        <span class="detail-value" v-if="item.paramType != 'switch'">{{ item.value || '0' }}{{ item.unit || '' }}</span>
                        <span class="detail-value" v-else>{{ item | initValue }}{{ item.unit || '' }}</span>
                    </div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import util from "../../utils/util.js";

export default {
	name: 'PropertyAssessmentList',
	data() {
		return {
			util: util,
			tableData: [
				
			],
			pageParam: {
				url: this.$Config.apiUrl.getPropertyAssessmentList, // 假设这是获取资产评估列表的接口
				method: "post",
				params: {
					provinceCode: "",
					cityCode: "",
					districtCode: "",
					userPhone: "",
					startTime: "",
					endTime: ""
				},
                freshCtrl: 1,
			},
			// 数据统计
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				}
			},
            total: 0,
            detailDialogVisible: false,
            currentRow: {}
		};
	},
	mounted() {
        this.pageParam.freshCtrl++; 
	},
    filters: {
        initValue (row) {
            let options = row.options ? JSON.parse(row.options) : [] 
            let targetInfo = options.find(option => option.value === row.value);
            return targetInfo ? targetInfo.label : '-'
        }
    },
	methods: {
		// 设置表格数据
		setTableData(data) {
			this.tableData = data;
		},

		// 重置搜索条件
		handlerRest() {
			this.pageParam.params = {
				provinceCode: "",
				cityCode: "",
				districtCode: "",
				userPhone: "",
				startTime: "",
				endTime: ""
			};
			this.handlerSearch();
		},

		// 执行搜索
		handlerSearch() {
			this.$refs['propertyPage'].pageNum = 1;
			this.pageParam.freshCtrl++;
		},

		// 查看详情
		handleViewDetail(row) {
			this.currentRow = row || {};
			this.detailDialogVisible = true;
		}
	}
};
</script>

<style scoped lang="scss">
.data-statistics {
	margin: 10px 0;
	padding: 10px;
	background-color: #f5f7fa;
	border-radius: 4px;
	font-size: 14px;
	color: #666;
	line-height: 1.8;
}

.el-table th {
	background-color: #f5f7fa;
}

.el-table .cell {
	text-align: center;
}

/* 表格列宽度调整 */
.el-table-column {
	min-width: 100px;
}

/* 确保表格内容不被截断 */
.el-table .cell {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
    /*width: 0;宽度为0隐藏*/
    width: 0 !important;
    height: 0 !important;
}
/deep/ .el-table__fixed, /deep/ .el-table__fixed-right{
    height: 100% !important;
}

.detail-content {
	max-height: 60vh;
	overflow-y: auto;
	padding-right: 10px;
}
.detail-section-title {
	font-size: 14px;
	font-weight: bold;
	color: #333;
	margin: 16px 0 12px;
	padding-left: 8px;
	border-left: 3px solid #409EFF;
}
.detail-section-title:first-child {
	margin-top: 0;
}
.detail-grid {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 12px;
}
.detail-item {
	display: flex;
	align-items: center;
	padding: 10px 12px;
	background: #f5f7fa;
	border-radius: 4px;
}
.detail-label {
	color: #666;
	font-size: 13px;
	margin-right: 8px;
	white-space: nowrap;
}
.detail-value {
	color: #333;
	font-size: 13px;
	font-weight: 500;
	flex: 1;
	text-align: right;
	word-break: break-all;
}
.detail-icon {
	width: 20px;
	height: 20px;
	margin-right: 8px;
	flex-shrink: 0;
	object-fit: contain;
}

/* 资产估值单独模块样式 */
.detail-asset-value {
	// background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	border-radius: 8px;
	text-align: left;
	margin-bottom: 20px;
}
.asset-label {
	color: #333333;
	font-size: 14px;
	margin-bottom: 8px;
}
.asset-value {
	color: #333333;
	font-size: 40px;
	font-weight: bold;
	line-height: 1;
}
.asset-unit {
	font-size: 16px;
	margin-left: 4px;
	opacity: 0.9;
}
</style>